import { asyncRoutes } from './index'

function hasPermission(auths, route) {
  if (route.meta && route.meta.auths) {
    if (!auths || auths.length === 0) {
      return false
    }
    let tag = false
    for (let i = 0; i < auths.length; i++) {
      // eslint-disable-next-line no-labels
      loop:
      for (let k = 0; k < route.meta.auths.length; k++) {
        if (auths[i].substr(0, route.meta.auths[k].level * 2) === route.meta.auths[k].code) {
          tag = true
          // eslint-disable-next-line no-labels
          break loop
        }
      }
    }
    return tag
  } else {
    return true
  }
}

export function filterAsyncRoutes(routes, auths) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(auths, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, auths)
      }
      res.push(tmp)
    }
  })
  // console.log(res)
  return res
}

export function accessedRoutes(auths) {
  const routes = filterAsyncRoutes(asyncRoutes, auths)
  return routes
}
